import { useQuery } from '@tanstack/react-query';
import { Percent, Calculator } from 'lucide-react';
import { api } from '../../lib/api';

export function ConsumptionTaxPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['consumption-tax'],
    queryFn: () => api.get<{ data: any[] }>('/api/tax/consumption-tax'),
  });

  return (
    <div className="space-y-6 animate-fadeIn">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>消費税申告書作成</h1>
        <button className="flex items-center gap-2 px-4 py-2 rounded-lg text-white font-medium" style={{ backgroundColor: 'var(--accent-color)' }}>
          <Calculator size={18} />消費税計算
        </button>
      </div>
      <div className="card p-6">
        {isLoading ? (
          <div className="flex items-center justify-center h-64"><div className="w-8 h-8 border-2 border-blue-600/30 border-t-blue-600 rounded-full animate-spin" /></div>
        ) : data?.data.length === 0 ? (
          <div className="text-center py-12">
            <Percent size={48} className="mx-auto mb-4" style={{ color: 'var(--text-muted)' }} />
            <p style={{ color: 'var(--text-secondary)' }}>消費税申告データがありません</p>
            <p className="text-sm mt-2" style={{ color: 'var(--text-muted)' }}>「消費税計算」ボタンから計算を開始してください</p>
          </div>
        ) : (
          <div className="space-y-4">
            {data?.data.map((tax: any) => (
              <div key={tax.id} className="p-4 rounded-lg border" style={{ borderColor: 'var(--border-color)' }}>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div>
                    <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>課税売上</p>
                    <p className="text-lg font-mono font-bold" style={{ color: 'var(--text-primary)' }}>¥{parseFloat(tax.taxableSales).toLocaleString()}</p>
                  </div>
                  <div>
                    <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>仮受消費税</p>
                    <p className="text-lg font-mono font-bold" style={{ color: 'var(--text-primary)' }}>¥{parseFloat(tax.outputTax).toLocaleString()}</p>
                  </div>
                  <div>
                    <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>仮払消費税</p>
                    <p className="text-lg font-mono font-bold" style={{ color: 'var(--text-primary)' }}>¥{parseFloat(tax.inputTax).toLocaleString()}</p>
                  </div>
                  <div>
                    <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>納付税額</p>
                    <p className="text-lg font-mono font-bold" style={{ color: parseFloat(tax.taxDue) > 0 ? 'var(--error)' : 'var(--success)' }}>¥{parseFloat(tax.taxDue).toLocaleString()}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

